import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('cardioai_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Password Recovery API
export const forgotPassword = async (email) => {
  const response = await axios.post(`${API}/auth/forgot-password`, { email });
  return response.data;
};

export const validateResetToken = async (token) => {
  const response = await axios.get(`${API}/auth/reset-password/validate`, { params: { token } });
  return response.data;
};

export const resetPassword = async (token, password) => {
  const response = await axios.post(`${API}/auth/reset-password`, { token, password });
  return response.data;
};

// Profile API
export const getProfile = async () => {
  const response = await axios.get(`${API}/profile`, { headers: getAuthHeaders() });
  return response.data;
};

export const saveProfile = async (profileData) => {
  const response = await axios.post(`${API}/profile`, profileData, { headers: getAuthHeaders() });
  return response.data;
};

// Workout Plans API
export const generateWorkoutPlan = async (planData) => {
  const response = await axios.post(`${API}/workout-plans`, planData, { headers: getAuthHeaders() });
  return response.data;
};

export const getWorkoutPlans = async () => {
  const response = await axios.get(`${API}/workout-plans`, { headers: getAuthHeaders() });
  return response.data;
};

export const getWorkoutPlan = async (planId) => {
  const response = await axios.get(`${API}/workout-plans/${planId}`, { headers: getAuthHeaders() });
  return response.data;
};

export const updatePlanStatus = async (planId, status) => {
  const response = await axios.put(`${API}/workout-plans/${planId}/status`, { status }, { headers: getAuthHeaders() });
  return response.data;
};

export const deleteWorkoutPlan = async (planId) => {
  const response = await axios.delete(`${API}/workout-plans/${planId}`, { headers: getAuthHeaders() });
  return response.data;
};

// Exercises API
export const getExercises = async (location = null, category = null) => {
  const params = new URLSearchParams();
  if (location) params.append('location', location);
  if (category) params.append('category', category);
  const response = await axios.get(`${API}/exercises?${params.toString()}`);
  return response.data;
};

export const getExercise = async (exerciseId) => {
  const response = await axios.get(`${API}/exercises/${exerciseId}`);
  return response.data;
};

// Progression API
export const addProgression = async (progressionData) => {
  const response = await axios.post(`${API}/progression`, progressionData, { headers: getAuthHeaders() });
  return response.data;
};

export const getAllProgression = async () => {
  const response = await axios.get(`${API}/progression`, { headers: getAuthHeaders() });
  return response.data;
};

export const getPlanProgression = async (planId) => {
  const response = await axios.get(`${API}/progression/${planId}`, { headers: getAuthHeaders() });
  return response.data;
};

// Stats API
export const getStats = async () => {
  const response = await axios.get(`${API}/stats`, { headers: getAuthHeaders() });
  return response.data;
};

// Checkout/Payment API
export const createCheckout = async (planId, originUrl) => {
  const response = await axios.post(`${API}/checkout/create`, 
    { plan_id: planId, origin_url: originUrl },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const getCheckoutStatus = async (sessionId) => {
  const response = await axios.get(`${API}/checkout/status/${sessionId}`, { headers: getAuthHeaders() });
  return response.data;
};

export default {
  getProfile,
  saveProfile,
  generateWorkoutPlan,
  getWorkoutPlans,
  getWorkoutPlan,
  updatePlanStatus,
  deleteWorkoutPlan,
  getExercises,
  getExercise,
  addProgression,
  getAllProgression,
  getPlanProgression,
  getStats,
  createCheckout,
  getCheckoutStatus
};
